import React from 'react';
import styled from 'styled-components';

export default styled.div`
     border: 2px solid #84bd80;
     padding: 10px;
     margin: 12px;
     background-color: #dbffd9;
     h1,h2,h3{
          text-transform: uppercase;
          color:#052f01;
     }
     h3{
          font-size: 23px;
          margin:0px;
     }
     .fas{
          float:right;
          color:#84bd80;
          font-size: 25px;
          font-size: 28px;
          margin-top: -5px;          
     }
     table{
          margin:0px;
     }

     &.error{
          border: 2px solid #170601;
          background-color: #fc9292;
          h1,h2,h3{
               color:#000000;
          .fas{
               color:#430000;
          }
     }
     }
`;
